export { initPostHog, posthog } from './posthog';
export { PostHogProvider } from './PostHogProvider';
export { safeCapture } from './safe-capture';
export {
  applyCapture,
  applyReplay,
  applyAutocapture,
  applyPersistence,
} from './posthog';
export { isSensitiveRoute, isPublicMarketingRoute } from './sensitive-routes';
export {
  getConsent,
  setConsent,
  getReplayConsent,
  setReplayConsent,
  CONSENT_STORAGE_KEY,
  CONSENT_CHANGED_EVENT,
  REPLAY_CONSENT_STORAGE_KEY,
  REPLAY_CONSENT_CHANGED_EVENT,
  type ConsentChoice,
  type ReplayConsentChoice,
} from './consent';
export {
  setUserAnalyticsPreference,
  readAnalyticsOptOut,
  isUserObjected,
  USER_OPTOUT_CHANGED_EVENT,
} from './user-optout';
